module.exports = __webpack_public_path__ + "static/SMB-Marketing-b1a41aad5fea57ae58de3881631a36bb.png";